import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { VOUCHER_REDEEM_ROUTE } from '@mwe/constants';

@Injectable({
  providedIn: 'root',
})
export class VoucherRedeemLogic {
  private router = inject(Router);

  redeemVoucher(): void {
    this.router.navigateByUrl(`/${VOUCHER_REDEEM_ROUTE}`);
  }
}
